export const options_origen_devolucion = [
  "Devoluciones CDS Clientes",
  "Devoluciones ML FULL",
  "Devoluciones ML Clientes",
  "Producto Dañado",
  "Ingreso por RMA",
  "Ingreso por Servicio Técnico",
  "Productos Clientes",
];
export const options_deposito_destino = [
  "Taller Donato (DS)",
  "Donato (MM)",
  "Donato (SP)",
  "Donato (DS)",
  "Taller Donato (MM)",
  "Taller Donato (SP)",
  "Taller Donato (DS)",
  "No aplica",
];
export const options_condicion = [
  "El producto llegó dañado",
  "La devolución está incompleta",
  "Devolvieron un producto distinto",
  "El producto no está en el paquete",
  "Packaging Incompleto",
  "El producto está ok",
  "Packaging roto y signo de uso que requiere mantenimiento",
  "El Packaging está roto",
  "El producto no funciona",
  "Backlog Antiguo - Taller",
  "Backlog Antiguo - SKU Nuevo",
  "El producto le llegó dañado al Cliente",
  "El producto le llegó Incompleto al Cliente",
  "Al cliente le llegó otro producto",
  "No fue posible realizar la entrega",
  "Backlog Antiguo - Stage 4",
  "Backlog Antiguo - Stage 3",
  "Backlog Antiguo - Stage 2",
  "Backlog Antiguo - Stage 1",
  "No recibimos el producto",
];
export const options_sintoma = [
  "Pierde agua",
  "No vincula con la app",
  "No calienta",
  "Producto roto",
  "No pesa",
  "No Calibra",
  "Sin Sonido",
  "Marcha hacia atrás",
  "No giran los cepillos",
  "Movimiento involuntario",
  "Se tilda",
  "Se choca",
  "No presuriza",
  "No corta en automático",
  "Gira al revés",
  "Sobrecalienta",
  "No brinda voltaje",
  "No retiene la carga de batería",
  "Mediciones imprecisas",
  "No enciende",
  "Enciende solo",
  "No desinfla",
  "No infla",
  "No se ven los números en la pantalla",
  "Enciende y se apaga",
  "Pierde Aire",
  "Packaging dañado",
  "Trabado / Obstruido",
  "No funciona la mopa",
  "Detalles estéticos",
  "Producto Nuevo",
  "No apaga",
  "No vincula canal B",
  "No vibra",
  "Hace Ruido",
  "No aspira",
  "No elimina los errores",
  "Limpieza",
  "No es lo que esperaba",
  "Pieza/s faltante/s",
  "No enfoca",
  "Funcionamiento intermitente",
  "No da presion",
  "Desperfectos en la Imagen",
  "Encastré deficiente",
  "En corto",
  "No es lo que pedí",
  "Marcas de Uso",
  "No funciona mezclador",
  "Sin Conexión",
  "El producto le llego tarde",
  "Funciona con Poca / Sin Potencia",
  "VENTA CANCELADA",
  "Descalibrado/a",
  "Enciende solo con pilas",
  "No arroja información / resultados",
  "Olor a quemado",
  "Movimientos incorrectos",
  "Piezas Sueltas / Desajustadas",
  "Pieza/s Dañada/s",
  "Marcas de Golpes",
  "Devolvieron un producto distinto",
  "No Humidifica",
  "La Potencia Varía Sola",
  "No Amplifica",
  "No Carga Correctamente",
  "No Cose",
  "Devolución FULL",
  "Da Corriente",
  "No fue posible realizar la entrega",
  "Consume muy rápido las baterías",
  "No Traba",
  "Pierde Aceite",
  "No Mide",
  "No Trapea",
  "Pantalla En Blanco",
  "No Varía el Amperaje",
  "No aplica",
  "No se puede configurar",
  "Descosido",
  "No Afina",
  "No Gira",
  "No brinda Amperaje correcto",
  "No succiona",
  "Recalienta",
  "Interferencia",
  "No enciende led",
];
export const options_aceptamos_devolucion_safe = ["SI", "NO", "NO APLICA"];
export const data_aceptamos_devolucion = [
  { id: 1, name: "SI" },
  { id: 2, name: "NO" },
  { id: 3, name: "NO APLICA" },
];
export const options_tecnico_responsable = [
  "Tecnico 1",
  "Tecnico 2",
  "Tecnico 3",
  "Tecnico 4",
  "Tecnico 5",
];
export const options_lote = ["Lote 1", "Lote 2", "Lote 3", "Lote 4", "Lote 5"];
export const status_options = [
  {
    id: 1,
    nombre_estado: "Pendiente de revision",
  },
  {
    id: 2,
    nombre_estado: "Procesado",
  },
  {
    id: 3,
    nombre_estado: "Taller ",
  },
  {
    id: 4,
    nombre_estado: "Finalizado",
  },
];
export const mockData = [
  {
    aceptamos_devolucion: "NO APLICA",
    compradores_ciudad: "Chacarita",
    compradores_codigo_postal: "1427",
    compradores_comprador: "GASTON GERARDO GONZALEZ",
    compradores_dni: "20183331281",
    compradores_domicilio:
      'Donato Álvarez 2643 / "Referencia: Depósito de portón negro Entre: Paz Soldan y Av. Elcano"',
    compradores_estado: "Capital Federal",
    compradores_pais: "Argentina",
    devoluciones_fecha_en_camino: "1990-01-01T02:00:00.000Z",
    devoluciones_fecha_entregado: "1990-01-01T02:00:00.000Z",
    devoluciones_forma_de_entrega: " ",
    devoluciones_numero_de_seguimiento: " ",
    devoluciones_transportista: " ",
    devoluciones_unidades: 0,
    devoluciones_url_de_seguimiento: " ",
    envios_fecha_en_camino: "2024-02-28T03:00:00.000Z",
    envios_fecha_entregado: "2024-02-29T03:00:00.000Z",
    envios_forma_de_entrega: "Mercado Envíos Full",
    envios_numero_de_seguimiento: "38191274868924",
    envios_transportista: "Reprocesos Carrito",
    envios_url_de_seguimiento:
      "https://www.andreani.com/#!/informacionEnvio/38191274868924",
    estado: 1,
    facturacion_al_comprador_condicion_fiscal: "IVA Responsable Inscripto",
    facturacion_al_comprador_datos_personales_o_de_empresa:
      "GASTON GERARDO GONZALEZ",
    facturacion_al_comprador_direccion:
      "36 160 SN, LA PLATA NOROESTE CALLE 50 - C.P.: 1900, BUENOS AIRES",
    facturacion_al_comprador_factura_adjunta: "Factura adjunta",
    facturacion_al_comprador_tipo_y_numero_de_documento: "CUIT 20183331281",
    id_condicion: 4,
    id_deposito_dest: 3,
    id_origen_dev: 2,
    id_sintoma: 8,
    identificador: "100",
    movimientos_vs_inicial: false,
    nombre_estado: "Pendiente de revision",
    publicaciones_num_de_publicacion: "MLA1446744694",
    publicaciones_precio_unitario_de_venta_de_la_publicacion_ars: "52000",
    publicaciones_sku: "BP30L-9M",
    publicaciones_tienda_oficial: "Femmto Argentina",
    publicaciones_tiene_cuotas_agregadas: "No",
    publicaciones_titulo_de_la_publicacion:
      "Bomba Presurizadora Femmto Bp30l-9m 100w - 220v",
    publicaciones_variante: " ",
    publicidad_venta_por_publicidad: " ",
    reclamos_con_mediacion: "No",
    reclamos_reclamo_abierto: "No",
    reclamos_reclamo_cerrado: "1",
    reclamos_unidades: 0,
    update_timestamp: "2024-03-26T14:36:41.920Z",
    ventas_anulaciones_y_reembolsos_ars: "-41960",
    ventas_cargo_por_venta_e_impuestos: "-19339",
    ventas_costos_de_envio: "-4649",
    ventas_descripcion_del_estado:
      "Tenés hasta el martes 5 de marzo para avisarnos cómo llegó el producto. Después de esa fecha, asumiremos que te llegó tal como esperabas.",
    ventas_estado: "Devolución para revisar",
    ventas_fecha_de_venta: "2024-02-14T03:00:00.000Z",
    ventas_ingresos_por_envio_ars: "0",
    ventas_ingresos_por_productos_ars: "0",
    ventas_mes_de_facturacion_de_tus_cargos: " ",
    ventas_num_de_venta: "2000007601253664326",
    ventas_paquete_de_varios_productos: "No",
    ventas_total_ars: "-13949",
    ventas_unidades: 1,
  },
  {
    aceptamos_devolucion: "NO APLICA",
    compradores_ciudad: "Chacarita",
    compradores_codigo_postal: "1427",
    compradores_comprador: "GASTON GERARDO GONZALEZ",
    compradores_dni: "20183331281",
    compradores_domicilio:
      'Donato Álvarez 2643 / "Referencia: Depósito de portón negro Entre: Paz Soldan y Av. Elcano"',
    compradores_estado: "Capital Federal",
    compradores_pais: "Argentina",
    devoluciones_fecha_en_camino: "1990-01-01T02:00:00.000Z",
    devoluciones_fecha_entregado: "1990-01-01T02:00:00.000Z",
    devoluciones_forma_de_entrega: " ",
    devoluciones_numero_de_seguimiento: " ",
    devoluciones_transportista: " ",
    devoluciones_unidades: 0,
    devoluciones_url_de_seguimiento: " ",
    envios_fecha_en_camino: "2024-02-28T03:00:00.000Z",
    envios_fecha_entregado: "2024-02-29T03:00:00.000Z",
    envios_forma_de_entrega: "Mercado Envíos Full",
    envios_numero_de_seguimiento: "102894899481237",
    envios_transportista: "Reprocesos Carrito",
    envios_url_de_seguimiento:
      "https://www.andreani.com/#!/informacionEnvio/102894899481237",
    estado: 1,
    facturacion_al_comprador_condicion_fiscal: "IVA Responsable Inscripto",
    facturacion_al_comprador_datos_personales_o_de_empresa:
      "GASTON GERARDO GONZALEZ",
    facturacion_al_comprador_direccion:
      "36 160 SN, LA PLATA NOROESTE CALLE 50 - C.P.: 1900, BUENOS AIRES",
    facturacion_al_comprador_factura_adjunta: "Factura adjunta",
    facturacion_al_comprador_tipo_y_numero_de_documento: "CUIT 20183331281",
    id_condicion: 4,
    id_deposito_dest: 3,
    id_origen_dev: 2,
    id_sintoma: 8,
    identificador: "101",
    movimientos_vs_inicial: false,
    nombre_estado: "Pendiente de revision",
    publicaciones_num_de_publicacion: "MLA1446744694",
    publicaciones_precio_unitario_de_venta_de_la_publicacion_ars: "52000",
    publicaciones_sku: "BP30L-9M",
    publicaciones_tienda_oficial: "Femmto Argentina",
    publicaciones_tiene_cuotas_agregadas: "No",
    publicaciones_titulo_de_la_publicacion:
      "Bomba Presurizadora Femmto Bp30l-9m 100w - 220v",
    publicaciones_variante: " ",
    publicidad_venta_por_publicidad: " ",
    reclamos_con_mediacion: "No",
    reclamos_reclamo_abierto: "No",
    reclamos_reclamo_cerrado: "1",
    reclamos_unidades: 0,
    update_timestamp: "2024-03-26T14:36:41.920Z",
    ventas_anulaciones_y_reembolsos_ars: "-41960",
    ventas_cargo_por_venta_e_impuestos: "-19339",
    ventas_costos_de_envio: "-4649",
    ventas_descripcion_del_estado:
      "Tenés hasta el martes 5 de marzo para avisarnos cómo llegó el producto. Después de esa fecha, asumiremos que te llegó tal como esperabas.",
    ventas_estado: "Devolución para revisar",
    ventas_fecha_de_venta: "2024-02-14T03:00:00.000Z",
    ventas_ingresos_por_envio_ars: "0",
    ventas_ingresos_por_productos_ars: "0",
    ventas_mes_de_facturacion_de_tus_cargos: " ",
    ventas_num_de_venta: "200000760201167423",
    ventas_paquete_de_varios_productos: "No",
    ventas_total_ars: "-13949",
    ventas_unidades: 1,
  },
  {
    aceptamos_devolucion: "NO APLICA",
    compradores_ciudad: "Chacarita",
    compradores_codigo_postal: "1427",
    compradores_comprador: "GASTON GERARDO GONZALEZ",
    compradores_dni: "20183331281",
    compradores_domicilio:
      'Donato Álvarez 2643 / "Referencia: Depósito de portón negro Entre: Paz Soldan y Av. Elcano"',
    compradores_estado: "Capital Federal",
    compradores_pais: "Argentina",
    devoluciones_fecha_en_camino: "1990-01-01T02:00:00.000Z",
    devoluciones_fecha_entregado: "1990-01-01T02:00:00.000Z",
    devoluciones_forma_de_entrega: " ",
    devoluciones_numero_de_seguimiento: " ",
    devoluciones_transportista: " ",
    devoluciones_unidades: 0,
    devoluciones_url_de_seguimiento: " ",
    envios_fecha_en_camino: "2024-02-28T03:00:00.000Z",
    envios_fecha_entregado: "2024-02-29T03:00:00.000Z",
    envios_forma_de_entrega: "Mercado Envíos Full",
    envios_numero_de_seguimiento: "66472424835838",
    envios_transportista: "Reprocesos Carrito",
    envios_url_de_seguimiento:
      "https://www.andreani.com/#!/informacionEnvio/66472424835838",
    estado: 2,
    facturacion_al_comprador_condicion_fiscal: "IVA Responsable Inscripto",
    facturacion_al_comprador_datos_personales_o_de_empresa:
      "GASTON GERARDO GONZALEZ",
    facturacion_al_comprador_direccion:
      "36 160 SN, LA PLATA NOROESTE CALLE 50 - C.P.: 1900, BUENOS AIRES",
    facturacion_al_comprador_factura_adjunta: "Factura adjunta",
    facturacion_al_comprador_tipo_y_numero_de_documento: "CUIT 20183331281",
    id_condicion: 4,
    id_deposito_dest: 3,
    id_origen_dev: 2,
    id_sintoma: 8,
    identificador: "102",
    movimientos_vs_inicial: false,
    nombre_estado: "Pendiente de revision",
    publicaciones_num_de_publicacion: "MLA1446744694",
    publicaciones_precio_unitario_de_venta_de_la_publicacion_ars: "52000",
    publicaciones_sku: "BP30L-9M",
    publicaciones_tienda_oficial: "Femmto Argentina",
    publicaciones_tiene_cuotas_agregadas: "No",
    publicaciones_titulo_de_la_publicacion:
      "Bomba Presurizadora Femmto Bp30l-9m 100w - 220v",
    publicaciones_variante: " ",
    publicidad_venta_por_publicidad: " ",
    reclamos_con_mediacion: "No",
    reclamos_reclamo_abierto: "No",
    reclamos_reclamo_cerrado: "1",
    reclamos_unidades: 0,
    update_timestamp: "2024-03-26T14:36:41.920Z",
    ventas_anulaciones_y_reembolsos_ars: "-41960",
    ventas_cargo_por_venta_e_impuestos: "-19339",
    ventas_costos_de_envio: "-4649",
    ventas_descripcion_del_estado:
      "Tenés hasta el martes 5 de marzo para avisarnos cómo llegó el producto. Después de esa fecha, asumiremos que te llegó tal como esperabas.",
    ventas_estado: "Devolución para revisar",
    ventas_fecha_de_venta: "2024-02-14T03:00:00.000Z",
    ventas_ingresos_por_envio_ars: "0",
    ventas_ingresos_por_productos_ars: "0",
    ventas_mes_de_facturacion_de_tus_cargos: " ",
    ventas_num_de_venta: "20000076020089675",
    ventas_paquete_de_varios_productos: "No",
    ventas_total_ars: "-13949",
    ventas_unidades: 1,
  },
  {
    aceptamos_devolucion: "NO APLICA",
    compradores_ciudad: "Chacarita",
    compradores_codigo_postal: "1427",
    compradores_comprador: "GASTON GERARDO GONZALEZ",
    compradores_dni: "20183331281",
    compradores_domicilio:
      'Donato Álvarez 2643 / "Referencia: Depósito de portón negro Entre: Paz Soldan y Av. Elcano"',
    compradores_estado: "Capital Federal",
    compradores_pais: "Argentina",
    devoluciones_fecha_en_camino: "1990-01-01T02:00:00.000Z",
    devoluciones_fecha_entregado: "1990-01-01T02:00:00.000Z",
    devoluciones_forma_de_entrega: " ",
    devoluciones_numero_de_seguimiento: " ",
    devoluciones_transportista: " ",
    devoluciones_unidades: 0,
    devoluciones_url_de_seguimiento: " ",
    envios_fecha_en_camino: "2024-02-28T03:00:00.000Z",
    envios_fecha_entregado: "2024-02-29T03:00:00.000Z",
    envios_forma_de_entrega: "Mercado Envíos Full",
    envios_numero_de_seguimiento: "8874328569356",
    envios_transportista: "Reprocesos Carrito",
    envios_url_de_seguimiento:
      "https://www.andreani.com/#!/informacionEnvio/8874328569356",
    estado: 2,
    facturacion_al_comprador_condicion_fiscal: "IVA Responsable Inscripto",
    facturacion_al_comprador_datos_personales_o_de_empresa:
      "GASTON GERARDO GONZALEZ",
    facturacion_al_comprador_direccion:
      "36 160 SN, LA PLATA NOROESTE CALLE 50 - C.P.: 1900, BUENOS AIRES",
    facturacion_al_comprador_factura_adjunta: "Factura adjunta",
    facturacion_al_comprador_tipo_y_numero_de_documento: "CUIT 20183331281",
    id_condicion: 4,
    id_deposito_dest: 3,
    id_origen_dev: 2,
    id_sintoma: 8,
    identificador: "103",
    movimientos_vs_inicial: false,
    nombre_estado: "Pendiente de revision",
    publicaciones_num_de_publicacion: "MLA1446744694",
    publicaciones_precio_unitario_de_venta_de_la_publicacion_ars: "52000",
    publicaciones_sku: "BP30L-9M",
    publicaciones_tienda_oficial: "Femmto Argentina",
    publicaciones_tiene_cuotas_agregadas: "No",
    publicaciones_titulo_de_la_publicacion:
      "Bomba Presurizadora Femmto Bp30l-9m 100w - 220v",
    publicaciones_variante: " ",
    publicidad_venta_por_publicidad: " ",
    reclamos_con_mediacion: "No",
    reclamos_reclamo_abierto: "No",
    reclamos_reclamo_cerrado: "1",
    reclamos_unidades: 0,
    update_timestamp: "2024-03-26T14:36:41.920Z",
    ventas_anulaciones_y_reembolsos_ars: "-41960",
    ventas_cargo_por_venta_e_impuestos: "-19339",
    ventas_costos_de_envio: "-4649",
    ventas_descripcion_del_estado:
      "Tenés hasta el martes 5 de marzo para avisarnos cómo llegó el producto. Después de esa fecha, asumiremos que te llegó tal como esperabas.",
    ventas_estado: "Devolución para revisar",
    ventas_fecha_de_venta: "2024-02-14T03:00:00.000Z",
    ventas_ingresos_por_envio_ars: "0",
    ventas_ingresos_por_productos_ars: "0",
    ventas_mes_de_facturacion_de_tus_cargos: " ",
    ventas_num_de_venta: "20000076020884453",
    ventas_paquete_de_varios_productos: "No",
    ventas_total_ars: "-13949",
    ventas_unidades: 1,
  },
  {
    aceptamos_devolucion: "NO APLICA",
    compradores_ciudad: "Chacarita",
    compradores_codigo_postal: "1427",
    compradores_comprador: "GASTON GERARDO GONZALEZ",
    compradores_dni: "20183331281",
    compradores_domicilio:
      'Donato Álvarez 2643 / "Referencia: Depósito de portón negro Entre: Paz Soldan y Av. Elcano"',
    compradores_estado: "Capital Federal",
    compradores_pais: "Argentina",
    devoluciones_fecha_en_camino: "1990-01-01T02:00:00.000Z",
    devoluciones_fecha_entregado: "1990-01-01T02:00:00.000Z",
    devoluciones_forma_de_entrega: " ",
    devoluciones_numero_de_seguimiento: " ",
    devoluciones_transportista: " ",
    devoluciones_unidades: 0,
    devoluciones_url_de_seguimiento: " ",
    envios_fecha_en_camino: "2024-02-28T03:00:00.000Z",
    envios_fecha_entregado: "2024-02-29T03:00:00.000Z",
    envios_forma_de_entrega: "Mercado Envíos Full",
    envios_numero_de_seguimiento: "845375372422457",
    envios_transportista: "Reprocesos Carrito",
    envios_url_de_seguimiento:
      "https://www.andreani.com/#!/informacionEnvio/845375372422457",
    estado: 3,
    facturacion_al_comprador_condicion_fiscal: "IVA Responsable Inscripto",
    facturacion_al_comprador_datos_personales_o_de_empresa:
      "GASTON GERARDO GONZALEZ",
    facturacion_al_comprador_direccion:
      "36 160 SN, LA PLATA NOROESTE CALLE 50 - C.P.: 1900, BUENOS AIRES",
    facturacion_al_comprador_factura_adjunta: "Factura adjunta",
    facturacion_al_comprador_tipo_y_numero_de_documento: "CUIT 20183331281",
    id_condicion: 4,
    id_deposito_dest: 3,
    id_origen_dev: 2,
    id_sintoma: 8,
    identificador: "104",
    movimientos_vs_inicial: false,
    nombre_estado: "Pendiente de revision",
    publicaciones_num_de_publicacion: "MLA1446744694",
    publicaciones_precio_unitario_de_venta_de_la_publicacion_ars: "52000",
    publicaciones_sku: "BP30L-9M",
    publicaciones_tienda_oficial: "Femmto Argentina",
    publicaciones_tiene_cuotas_agregadas: "No",
    publicaciones_titulo_de_la_publicacion:
      "Bomba Presurizadora Femmto Bp30l-9m 100w - 220v",
    publicaciones_variante: " ",
    publicidad_venta_por_publicidad: " ",
    reclamos_con_mediacion: "No",
    reclamos_reclamo_abierto: "No",
    reclamos_reclamo_cerrado: "1",
    reclamos_unidades: 0,
    update_timestamp: "2024-03-26T14:36:41.920Z",
    ventas_anulaciones_y_reembolsos_ars: "-41960",
    ventas_cargo_por_venta_e_impuestos: "-19339",
    ventas_costos_de_envio: "-4649",
    ventas_descripcion_del_estado:
      "Tenés hasta el martes 5 de marzo para avisarnos cómo llegó el producto. Después de esa fecha, asumiremos que te llegó tal como esperabas.",
    ventas_estado: "Devolución para revisar",
    ventas_fecha_de_venta: "2024-02-14T03:00:00.000Z",
    ventas_ingresos_por_envio_ars: "0",
    ventas_ingresos_por_productos_ars: "0",
    ventas_mes_de_facturacion_de_tus_cargos: " ",
    ventas_num_de_venta: "20000076020223516",
    ventas_paquete_de_varios_productos: "No",
    ventas_total_ars: "-13949",
    ventas_unidades: 1,
  },
  {
    aceptamos_devolucion: "NO APLICA",
    compradores_ciudad: "Chacarita",
    compradores_codigo_postal: "1427",
    compradores_comprador: "GASTON GERARDO GONZALEZ",
    compradores_dni: "20183331281",
    compradores_domicilio:
      'Donato Álvarez 2643 / "Referencia: Depósito de portón negro Entre: Paz Soldan y Av. Elcano"',
    compradores_estado: "Capital Federal",
    compradores_pais: "Argentina",
    devoluciones_fecha_en_camino: "1990-01-01T02:00:00.000Z",
    devoluciones_fecha_entregado: "1990-01-01T02:00:00.000Z",
    devoluciones_forma_de_entrega: " ",
    devoluciones_numero_de_seguimiento: " ",
    devoluciones_transportista: " ",
    devoluciones_unidades: 0,
    devoluciones_url_de_seguimiento: " ",
    envios_fecha_en_camino: "2024-02-28T03:00:00.000Z",
    envios_fecha_entregado: "2024-02-29T03:00:00.000Z",
    envios_forma_de_entrega: "Mercado Envíos Full",
    envios_numero_de_seguimiento: "113147576246245824",
    envios_transportista: "Reprocesos Carrito",
    envios_url_de_seguimiento:
      "https://www.andreani.com/#!/informacionEnvio/113147576246245824",
    estado: 3,
    facturacion_al_comprador_condicion_fiscal: "IVA Responsable Inscripto",
    facturacion_al_comprador_datos_personales_o_de_empresa:
      "GASTON GERARDO GONZALEZ",
    facturacion_al_comprador_direccion:
      "36 160 SN, LA PLATA NOROESTE CALLE 50 - C.P.: 1900, BUENOS AIRES",
    facturacion_al_comprador_factura_adjunta: "Factura adjunta",
    facturacion_al_comprador_tipo_y_numero_de_documento: "CUIT 20183331281",
    id_condicion: 4,
    id_deposito_dest: 3,
    id_origen_dev: 2,
    id_sintoma: 8,
    identificador: "105",
    movimientos_vs_inicial: false,
    nombre_estado: "Pendiente de revision",
    publicaciones_num_de_publicacion: "MLA1446744694",
    publicaciones_precio_unitario_de_venta_de_la_publicacion_ars: "52000",
    publicaciones_sku: "BP30L-9M",
    publicaciones_tienda_oficial: "Femmto Argentina",
    publicaciones_tiene_cuotas_agregadas: "No",
    publicaciones_titulo_de_la_publicacion:
      "Bomba Presurizadora Femmto Bp30l-9m 100w - 220v",
    publicaciones_variante: " ",
    publicidad_venta_por_publicidad: " ",
    reclamos_con_mediacion: "No",
    reclamos_reclamo_abierto: "No",
    reclamos_reclamo_cerrado: "1",
    reclamos_unidades: 0,
    update_timestamp: "2024-03-26T14:36:41.920Z",
    ventas_anulaciones_y_reembolsos_ars: "-41960",
    ventas_cargo_por_venta_e_impuestos: "-19339",
    ventas_costos_de_envio: "-4649",
    ventas_descripcion_del_estado:
      "Tenés hasta el martes 5 de marzo para avisarnos cómo llegó el producto. Después de esa fecha, asumiremos que te llegó tal como esperabas.",
    ventas_estado: "Devolución para revisar",
    ventas_fecha_de_venta: "2024-02-14T03:00:00.000Z",
    ventas_ingresos_por_envio_ars: "0",
    ventas_ingresos_por_productos_ars: "0",
    ventas_mes_de_facturacion_de_tus_cargos: " ",
    ventas_num_de_venta: "20000076066432345",
    ventas_paquete_de_varios_productos: "No",
    ventas_total_ars: "-13949",
    ventas_unidades: 1,
  },
  {
    aceptamos_devolucion: "NO APLICA",
    compradores_ciudad: "Chacarita",
    compradores_codigo_postal: "1427",
    compradores_comprador: "GASTON GERARDO GONZALEZ",
    compradores_dni: "20183331281",
    compradores_domicilio:
      'Donato Álvarez 2643 / "Referencia: Depósito de portón negro Entre: Paz Soldan y Av. Elcano"',
    compradores_estado: "Capital Federal",
    compradores_pais: "Argentina",
    devoluciones_fecha_en_camino: "1990-01-01T02:00:00.000Z",
    devoluciones_fecha_entregado: "1990-01-01T02:00:00.000Z",
    devoluciones_forma_de_entrega: " ",
    devoluciones_numero_de_seguimiento: " ",
    devoluciones_transportista: " ",
    devoluciones_unidades: 0,
    devoluciones_url_de_seguimiento: " ",
    envios_fecha_en_camino: "2024-02-28T03:00:00.000Z",
    envios_fecha_entregado: "2024-02-29T03:00:00.000Z",
    envios_forma_de_entrega: "Mercado Envíos Full",
    envios_numero_de_seguimiento: "7758636965364",
    envios_transportista: "Reprocesos Carrito",
    envios_url_de_seguimiento:
      "https://www.andreani.com/#!/informacionEnvio/7758636965364",
    estado: 4,
    facturacion_al_comprador_condicion_fiscal: "IVA Responsable Inscripto",
    facturacion_al_comprador_datos_personales_o_de_empresa:
      "GASTON GERARDO GONZALEZ",
    facturacion_al_comprador_direccion:
      "36 160 SN, LA PLATA NOROESTE CALLE 50 - C.P.: 1900, BUENOS AIRES",
    facturacion_al_comprador_factura_adjunta: "Factura adjunta",
    facturacion_al_comprador_tipo_y_numero_de_documento: "CUIT 20183331281",
    id_condicion: 4,
    id_deposito_dest: 3,
    id_origen_dev: 2,
    id_sintoma: 8,
    identificador: "106",
    movimientos_vs_inicial: false,
    nombre_estado: "Pendiente de revision",
    publicaciones_num_de_publicacion: "MLA1446744694",
    publicaciones_precio_unitario_de_venta_de_la_publicacion_ars: "52000",
    publicaciones_sku: "BP30L-9M",
    publicaciones_tienda_oficial: "Femmto Argentina",
    publicaciones_tiene_cuotas_agregadas: "No",
    publicaciones_titulo_de_la_publicacion:
      "Bomba Presurizadora Femmto Bp30l-9m 100w - 220v",
    publicaciones_variante: " ",
    publicidad_venta_por_publicidad: " ",
    reclamos_con_mediacion: "No",
    reclamos_reclamo_abierto: "No",
    reclamos_reclamo_cerrado: "1",
    reclamos_unidades: 0,
    update_timestamp: "2024-03-26T14:36:41.920Z",
    ventas_anulaciones_y_reembolsos_ars: "-41960",
    ventas_cargo_por_venta_e_impuestos: "-19339",
    ventas_costos_de_envio: "-4649",
    ventas_descripcion_del_estado:
      "Tenés hasta el martes 5 de marzo para avisarnos cómo llegó el producto. Después de esa fecha, asumiremos que te llegó tal como esperabas.",
    ventas_estado: "Devolución para revisar",
    ventas_fecha_de_venta: "2024-02-14T03:00:00.000Z",
    ventas_ingresos_por_envio_ars: "0",
    ventas_ingresos_por_productos_ars: "0",
    ventas_mes_de_facturacion_de_tus_cargos: " ",
    ventas_num_de_venta: "200000760201125632",
    ventas_paquete_de_varios_productos: "No",
    ventas_total_ars: "-13949",
    ventas_unidades: 1,
  },
  {
    aceptamos_devolucion: "NO APLICA",
    compradores_ciudad: "Chacarita",
    compradores_codigo_postal: "1427",
    compradores_comprador: "GASTON GERARDO GONZALEZ",
    compradores_dni: "20183331281",
    compradores_domicilio:
      'Donato Álvarez 2643 / "Referencia: Depósito de portón negro Entre: Paz Soldan y Av. Elcano"',
    compradores_estado: "Capital Federal",
    compradores_pais: "Argentina",
    devoluciones_fecha_en_camino: "1990-01-01T02:00:00.000Z",
    devoluciones_fecha_entregado: "1990-01-01T02:00:00.000Z",
    devoluciones_forma_de_entrega: " ",
    devoluciones_numero_de_seguimiento: " ",
    devoluciones_transportista: " ",
    devoluciones_unidades: 0,
    devoluciones_url_de_seguimiento: " ",
    envios_fecha_en_camino: "2024-02-28T03:00:00.000Z",
    envios_fecha_entregado: "2024-02-29T03:00:00.000Z",
    envios_forma_de_entrega: "Mercado Envíos Full",
    envios_numero_de_seguimiento: "360001133827420",
    envios_transportista: "Reprocesos Carrito",
    envios_url_de_seguimiento:
      "https://www.andreani.com/#!/informacionEnvio/360001133827420",
    estado: 4,
    facturacion_al_comprador_condicion_fiscal: "IVA Responsable Inscripto",
    facturacion_al_comprador_datos_personales_o_de_empresa:
      "GASTON GERARDO GONZALEZ",
    facturacion_al_comprador_direccion:
      "36 160 SN, LA PLATA NOROESTE CALLE 50 - C.P.: 1900, BUENOS AIRES",
    facturacion_al_comprador_factura_adjunta: "Factura adjunta",
    facturacion_al_comprador_tipo_y_numero_de_documento: "CUIT 20183331281",
    id_condicion: 4,
    id_deposito_dest: 3,
    id_origen_dev: 2,
    id_sintoma: 8,
    identificador: "107",
    movimientos_vs_inicial: false,
    nombre_estado: "Pendiente de revision",
    publicaciones_num_de_publicacion: "MLA1446744694",
    publicaciones_precio_unitario_de_venta_de_la_publicacion_ars: "52000",
    publicaciones_sku: "BP30L-9M",
    publicaciones_tienda_oficial: "Femmto Argentina",
    publicaciones_tiene_cuotas_agregadas: "No",
    publicaciones_titulo_de_la_publicacion:
      "Bomba Presurizadora Femmto Bp30l-9m 100w - 220v",
    publicaciones_variante: " ",
    publicidad_venta_por_publicidad: " ",
    reclamos_con_mediacion: "No",
    reclamos_reclamo_abierto: "No",
    reclamos_reclamo_cerrado: "1",
    reclamos_unidades: 0,
    update_timestamp: "2024-03-26T14:36:41.920Z",
    ventas_anulaciones_y_reembolsos_ars: "-41960",
    ventas_cargo_por_venta_e_impuestos: "-19339",
    ventas_costos_de_envio: "-4649",
    ventas_descripcion_del_estado:
      "Tenés hasta el martes 5 de marzo para avisarnos cómo llegó el producto. Después de esa fecha, asumiremos que te llegó tal como esperabas.",
    ventas_estado: "Devolución para revisar",
    ventas_fecha_de_venta: "2024-02-14T03:00:00.000Z",
    ventas_ingresos_por_envio_ars: "0",
    ventas_ingresos_por_productos_ars: "0",
    ventas_mes_de_facturacion_de_tus_cargos: " ",
    ventas_num_de_venta: "2000007602072796",
    ventas_paquete_de_varios_productos: "No",
    ventas_total_ars: "-13949",
    ventas_unidades: 1,
  },
];
